import moment from "moment";
import { DatePicker } from "@freightsimple/ui-core/DateTime/Controls/DatePicker";
import { asLocalDate } from "@freightsimple/time/branded-types";
import { locationsFirstAllowedDeadlineDate } from "../Helpers/locationsFirstAllowedDeadlineDate";

interface DeadlineDateControlProps {
  date: moment.Moment | undefined;
  pickupDate: string;
  earliestDeliveryDate: string | undefined;
  onDateChange: (date: moment.Moment | undefined) => void;
  disabled: boolean;
}

export function LocationsDeadlineDateInput(props: DeadlineDateControlProps) {
  const dayAfterPickup = moment(props.pickupDate).startOf("day").add(1, "day");
  const firstAllowedDate = locationsFirstAllowedDeadlineDate(
    props.pickupDate,
    props.earliestDeliveryDate,
  );
  const limitedByEarliestDelivery = firstAllowedDate.isAfter(
    dayAfterPickup,
    "day",
  );

  return (
    <DatePicker
      value={
        props.date ? asLocalDate(props.date.format("YYYY-MM-DD")) : undefined
      }
      onChange={function (selectedDate) {
        props.onDateChange(selectedDate ? moment(selectedDate) : undefined);
      }}
      disabled={props.disabled}
      disabledDate={(date) => moment(date).isBefore(firstAllowedDate, "day")}
      disabledHint={
        limitedByEarliestDelivery
          ? `The carrier's earliest delivery date is ${firstAllowedDate.format("MMMM D")}`
          : "Deadline must be after pickup date"
      }
    />
  );
}
